import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable, Subject} from 'rxjs';
import {MatTabNav} from '@angular/material/tabs';
import {ResizeService} from '../../shared/resize.service';
import {map, takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {UsersService} from '../../shared/users.service';
import {can} from '../../shared/permissions';
import {Permission} from 'smag-commons/dto/api';
import {PermissionManagementService} from './permission-management.service';

@Component({
    selector: 'app-perm-admin-panel',
    templateUrl: './perm-admin-panel.component.html',
    styleUrls: ['./perm-admin-panel.component.scss']
})
export class PermAdminPanelComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();
    @ViewChild('navBar') private navBar: MatTabNav;

    showMenu: Observable<boolean>;
    showUsersPermAssignments: Observable<boolean>;

    constructor(private readonly usersService: UsersService,
                private readonly permMgmtService: PermissionManagementService,
                private readonly resizeService: ResizeService,
                private readonly router: Router) {
        this.showMenu = null;
        this.showUsersPermAssignments = null;
    }

    ngOnInit() {
        this.showMenu = this.permMgmtService.menuShown;
        this.showUsersPermAssignments = combineLatest([
            this.permMgmtService.userAssignmentsEnabled,
            this.usersService.permissions
        ]).pipe(
            map(([userAssignments, userPerms]) => userAssignments && can(userPerms, Permission.READ)), // at least, must be able to READ users
            takeUntil(this.destroyed)
        );
        // see: https://github.com/angular/components/issues/6130
        //      https://github.com/angular/components/issues/3048
        this.resizeService.observe(['content']).pipe(
            takeUntil(this.destroyed)
        ).subscribe(() => {
            if (this.navBar) {
                this.navBar._alignInkBarToSelectedTab();
            }
        });
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    get currentUrl(): string {
        return this.router.url;
    }

    private isInUsersPermAssignments(): boolean {
        const segments = this.router.parseUrl(this.router.url)
            .root.children.primary.segments
            .map(segment => segment.path);
        return segments[0] === 'c' && segments[1] === 'permissions' && segments[2] === 'users-assignments';
    }
}
